import React from 'react'
import "./Insignia.css";

import defaultImage from "../images/awo/cat1.jpg"; // CAT I
import C1 from "../images/awo/cat1.jpg";
import C2 from "../images/awo/cat2.jpg";
import C3 from "../images/awo/cat3a.jpg";
import C4 from "../images/awo/cat3b.jpg";
import C5 from "../images/awo/cat3c.jpg";


const InsigniaAWO = (props) => {
    let image = defaultImage;
    
    switch(props.awo) {
        case "cat1":
            image = C1;
            break;
        case "cat2":
            image = C2;
            break;
        case "cat3a":
            image = C3;
            break;
        case "cat3b":
            image = C4;
            break;
        case "cat3c":
            image = C5;
            break;
        default:
            image = defaultImage;
    }
    
    return (
        <div className="insignia-awo">
            <img className="insignia-awo-image" src={image} alt="AWO Insignia" />
        </div>
    )
}
export default InsigniaAWO;
